// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LabelControl {
  margin-bottom: 5px;
  font-style: italic;
}
.LabelControl h2 {
  font-size: 20px;
  font-weight: bold;
  color: #353535;
}
.LabelControl p {
  font-size: 14px;
  font-weight: normal;
  color: #353535;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/Label.less"],"names":[],"mappings":"AAEA;EAEE,kBAAA;EACA,kBAAA;AAFF;AADA;EAMI,eAAA;EACA,iBAAA;EACA,cAAA;AAFJ;AANA;EAYI,eAAA;EACA,mBAAA;EACA,cAAA;AAHJ","sourcesContent":["@import '~common-controls/Style/Colors.less';\n\n.LabelControl {\n  // border-bottom: 1px solid @background-dark1;\n  margin-bottom: 5px;\n  font-style: italic;\n\n  h2 {\n    font-size: 20px;\n    font-weight: bold;\n    color: @text-gray1;\n  }\n\n  p {\n    font-size: 14px;\n    font-weight: normal;\n    color: @text-gray1;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
